module.exports = __webpack_public_path__ + "static/titan-in-the-outfield-5392b950419b12670e02472f66fe78d6.jpg";